import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import { useMemo } from "react";
import "./styles.scss";

// Custom arrow components for both styles
const CustomPrevArrow = ({ className, style, onClick, currentSlide, slideCount, slidesToShow, arrowStyle }) => {
  const isDisabled = currentSlide === 0;
  
  if (arrowStyle === "square") {
    return (
      <button 
        className={`${className} custom-arrow square-arrow ${isDisabled ? 'slick-disabled' : ''}`}
        onClick={isDisabled ? undefined : onClick}
        style={style}
        aria-label="Previous slide"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    );
  }
  
  // Default round arrow - let slick handle it with CSS
  return <div className={className} style={style} onClick={onClick} />;
};

const CustomNextArrow = ({ className, style, onClick, currentSlide, slideCount, slidesToShow, arrowStyle }) => {
  const isDisabled = currentSlide >= slideCount - slidesToShow;
  
  if (arrowStyle === "square") {
    return (
      <button 
        className={`${className} custom-arrow square-arrow ${isDisabled ? 'slick-disabled' : ''}`}
        onClick={isDisabled ? undefined : onClick}
        style={style}
        aria-label="Next slide"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    );
  }
  
  // Default round arrow - let slick handle it with CSS
  return <div className={className} style={style} onClick={onClick} />;
};

const MultiViewSlider = ({
  className,
  children,
  slidesNum = 2,
  arrowBottom = null,
  arrowTop = "50%",
  arrowLeft = "5px",
  arrowRight = "5px",
  arrowBorderColor = "white",
  arrowBackgroundColor = "white",
  arrowStyle = "round", // "round" or "square"
  speed = 1000,
  autoplay = false,
  infinite = false,
  arrows = true,
  responsive = [],
}) => {
  const childrenArray = Array.isArray(children) ? children : [children];
  const slideCount = childrenArray.length;

  const sliderSettings = useMemo(
    () => ({
      slidesToShow: slidesNum,
      slidesToScroll: slidesNum,
      autoplay,
      speed,
      infinite: slideCount > slidesNum ? infinite : false,
      arrows: slideCount > slidesNum ? arrows : false,
      dots: false,
      prevArrow: <CustomPrevArrow arrowStyle={arrowStyle} />,
      nextArrow: <CustomNextArrow arrowStyle={arrowStyle} />,
      responsive: [
        ...responsive,
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay,
            speed: 500,
            dots: false,
            infinite: slideCount > 1 ? infinite : false,
            arrows: slideCount > 1 ? !!arrows : false,
            centerMode: false,
            variableWidth: false,
            prevArrow: <CustomPrevArrow arrowStyle={arrowStyle} />,
            nextArrow: <CustomNextArrow arrowStyle={arrowStyle} />,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: <CustomPrevArrow arrowStyle={arrowStyle} />,
            nextArrow: <CustomNextArrow arrowStyle={arrowStyle} />,
          },
        },
      ],
    }),
    [autoplay, speed, infinite, arrows, responsive, slidesNum, slideCount, arrowStyle]
  );

  return (
    <div className={`multiViewSlider multiViewSlider--${arrowStyle}`}>
      <Slider
        className={className}
        {...sliderSettings}
        style={{
          "--arrow-left": arrowLeft,
          "--arrow-right": arrowRight,
          "--arrow-top": arrowTop,
          "--arrow-bottom": arrowBottom,
          "--border-color": arrowBorderColor,
          "--bg-color": arrowBackgroundColor,
        }}
      >
        {children}
      </Slider>
    </div>
  );
};

export default MultiViewSlider;